import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WriteIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M21.32 2.62C21.76 3.08 21.78 3.82 21.32 4.28L20.4 5.18L18.7 3.56L19.64 2.62C20.1 2.16 20.84 2.16 21.32 2.62ZM18.04 10.12H19.88V19.84H4.12V4.08H13.84V5.92H5.96V18H18.04V10.12ZM11.58 10.8L17.9 4.4L19.56 6.04L13.22 12.46L10.62 13.28L11.58 10.8Z" />
    </SvgIcon>
  );
});
